import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class IbodeGraphsDal {
  constructor(private httpClient: HttpClient) {}

  // First Row
  getPositionsPie(positions: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.ibodeGraphs + 'positionsPie' + `?positions=${positions}`);
  }

  getLastThree(isIadeResp: boolean, positions: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs + 'lastThree' + '?isIadeResp=' + isIadeResp + `&positions=${positions}`
    );
  }

  getTwoWeeksTeam(
    startDate: string,
    endDate: string,
    residency: string | undefined,
    positions: string,
    roles: string,
    effectifType: string,
    requestedDocuments: {
      anesthNeeds?: boolean;
      effectif?: boolean;
      nightEffectif?: boolean;
      nightGuard?: boolean;
      nightNeeds?: boolean;
      nurseNeeds?: boolean;
      residency?: boolean;
    }
  ): Observable<any> {
    return this.httpClient.post<any>(
      urlEndPoints.calendars +
        'effectifByDay?fromDate=' +
        startDate +
        '&toDate=' +
        endDate +
        `&residency=${residency}` +
        `&positions=${positions}` +
        `&roles=${roles}` +
        '&isFromCompetences=true',
      { requestedDocuments, effectifType }
    );
  }

  /////////////////////////////////
  // Second Row

  getAvgLevelPerSpecialtyPerRole(
    isIadeResp: boolean,
    startDay: string,
    endDay: string,
    residency: string,
    specialties: string,
    roles: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'avgLevelPerSpecialtyPerRole' +
        '?isIadeResp=' +
        isIadeResp +
        '&toDate=' +
        endDay +
        '&fromDate=' +
        startDay +
        `&residency=${residency}` +
        `&specialties=${specialties}` +
        `&roles=${roles}`
    );
  }
  /////////////////////////////////
  // Third Row

  getWaterFallPerRoleData(
    isIadeResp: boolean,
    startDay: string,
    endDay: string,
    residency: string,
    specialties: string,
    roles: string,
    positions: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'waterfallPerRole' +
        '?isIadeResp=' +
        isIadeResp +
        '&toDate=' +
        endDay +
        '&fromDate=' +
        startDay +
        `&residency=${residency}` +
        `&specialties=${specialties}` +
        `&roles=${roles}` +
        `&positions=${positions}`
    );
  }
  /////////////////////////////////
  // Forth Row

  getBubbleDataPerRole(
    isIadeResp: boolean,
    residency: string,
    positions: string,
    specialties: string,
    roles: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'effectifBubblesPerRole?isIadeResp=' +
        isIadeResp +
        `&residency=${residency}` +
        `&positions=${positions}` +
        `&specialties=${specialties}` +
        `&roles=${roles}`
    );
  }
  /////////////////////////////////
  // Fifth Row

  getFinaleGeneralStats(
    isIadeResp: boolean,
    residency: string,
    specialties: string,
    roles: string,
    positions: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'effectifPerAvgSpecialty?isIadeResp=' +
        isIadeResp +
        `&residency=${residency}` +
        `&specialties=${specialties}` +
        `&roles=${roles}` +
        `&positions=${positions}`
    );
  }

  /////////////////////////
  ////// One Onf //////////
  /////////////////////////

  // First Row

  getOneInfBarChart(nurseId: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.ibodeGraphs + 'barchartSpecialityLevel?nurseId=' + nurseId);
  }

  // Second Row

  getNurseLevelEvolution(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'nurseLevelEvolution?nurseId=' +
        nurseId +
        '&toDate=' +
        EndDay +
        '&fromDate=' +
        startDay
    );
  }

  getNurseEvolution(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs + 'nurseEvolution?nurseId=' + nurseId + '&toDate=' + EndDay + '&fromDate=' + startDay
    );
  }

  // Third Row

  getSpecialtyIntervention(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs + 'nurseHeader?nurseId=' + nurseId + '&toDate=' + EndDay + '&fromDate=' + startDay
    );
  }

  getNurseRankings(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs + 'nurseRankings?nurseId=' + nurseId + '&toDate=' + EndDay + '&fromDate=' + startDay
    );
  }

  getDoughnutData(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs +
        'piechartSpecialityIntervention?nurseId=' +
        nurseId +
        '&toDate=' +
        EndDay +
        '&fromDate=' +
        startDay
    );
  }

  // Specialties Progress

  getSpecialtiesProgress(nurseId: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.ibodeGraphs + 'leftTimeProgression?nurseId=' + nurseId);
  }

  getOneSpecialtyProgress(nurseId: string, specialtyId: string): Observable<any> {
    return this.httpClient.get<any>(
      urlEndPoints.ibodeGraphs + 'leftTimeProgressionBySpecialty?nurseId=' + nurseId + '&specialtyId=' + specialtyId
    );
  }

  getAllNursesReportsPDF(
    hospital: string,
    fromDate: string,
    toDate: string,
    showAnnex: boolean,
    showIndivExp: boolean,
    showRank: boolean
  ): Observable<any> {
    return this.httpClient.post<any>(
      urlEndPoints.ibodeGraphs +
        'reportsPDF' +
        '?hospital=' +
        hospital +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&showAnnex=' +
        showAnnex +
        '&showIndivExp=' +
        showIndivExp +
        '&showRank=' +
        showRank,
      {}
    );
  }
}
